import { FieldMetaState } from "react-final-form";
import { IFieldStatus } from "common-interfaces";

/**
 * Fonction utilis qui permet de determiner le statut d'un input de react-final-form
 */
export const getMandatoryFieldStatus = <FieldValue>(
  inputMeta?: FieldMetaState<FieldValue>
): IFieldStatus => {
  if (!inputMeta) return "UNCHECKED";

  /** Pas d'erreur si le champ est actif */
  if (inputMeta.active) return "UNCHECKED";

  /** Si le retour serveur indique une erreur, ou si la validation locale comporte des erreurs */
  if (inputMeta.touched && !inputMeta.active && inputMeta.error) {
    return "ERROR";
  }

  /** Si le retour serveur indique un succès et si la validation locale ne comporte PAS d'erreurs */
  if (inputMeta.touched && !inputMeta.active && !inputMeta.error) {
    return "SUCCESS";
  }

  /** Retourne UNCHECKED si le champ est ni en erreur ni en succès */
  return "UNCHECKED";
};
